import { render, staticRenderFns } from "./JobGroups.vue?vue&type=template&id=ff0893a6&"
import script from "./JobGroups.vue?vue&type=script&lang=js&"
export * from "./JobGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports